import React from 'react';
import { PropTypes } from 'prop-types';

import OnboardingCard from '../../../../components/OnboardingCard';

import {
  CardGrid,
  StyledActionFailed,
  NotificationCardTitle,
  StyledButton,
} from './styles';
import texts from './texts.json';

const FailureNotificationCard = ({
  message,
  onConfirmingFinalResult,
  isDarkTheme,
  color,
}) => (
  <CardGrid>
    <OnboardingCard $isDarkTheme={isDarkTheme}>
      <NotificationCardTitle>{message}</NotificationCardTitle>
      <StyledActionFailed />
      <StyledButton
        onClick={() => onConfirmingFinalResult(false)}
        $background={color}
        $isDarkTheme={isDarkTheme}
      >
        {texts.back}
      </StyledButton>
    </OnboardingCard>
  </CardGrid>
);

FailureNotificationCard.propTypes = {
  message: PropTypes.string.isRequired,
  onConfirmingFinalResult: PropTypes.func.isRequired,
  isDarkTheme: PropTypes.bool.isRequired,
  color: PropTypes.string,
};

FailureNotificationCard.defaultProps = {
  color: '',
};

export default FailureNotificationCard;
